<template>
    <div>
        <div class="columns">
            <div class="column is-3">
                <figure class="image is-circle">
                    <div class="overlay">

                    </div>
                    <img src="/img/user.png">
                </figure>
            </div>
            <div class="column">
                <p><strong>Nombre: </strong>{{user.profile.name}}</p>
                <p><strong>Apellido Paterno: </strong>{{user.profile.last_name}}</p>
                <p><strong>Apellido Materno: </strong>{{user.profile.other_name}}</p>
                <p><strong>Email: </strong>{{user.email}}</p>
                <p><strong>Fecha de Nacimiento</strong>{{user.profile.birthday}}</p>
                <p><strong>Genero: </strong>{{user.profile.gender | gender}}</p>
                <p><strong>Extensión: </strong>{{user.worker.extension}}</p>
                <p><strong>Teléfono Personal: </strong>{{user.worker.personal_phone}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "View",
        props:{
            user: {}
        }
    }
</script>

<style scoped lang="css">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: auto;
        text-align: center;
    }

    .avatar-uploader img {
        width: 178px;
        height: auto;
        display: block;
    }
</style>
